import { createFileRoute } from "@tanstack/react-router";
import { TransactionsTable, validateTransactionsSearch } from "./-transactions-table";

// Real implementation of Task 30 Part E, replacing the Task-22 placeholder:
// deposits with no matching invoice (TECH_VIEWER-gated). Thin wrapper around
// the shared `-transactions-table.tsx` with the preset locked — no visible
// "unmatched" toggle or operation filter anywhere on this page, per the
// plan's own wording ("transactions table preset to unmatched=true, filter
// locked").
export const Route = createFileRoute("/_app/unmatched-deposits")({
  validateSearch: validateTransactionsSearch,
  component: UnmatchedDepositsPage,
});

function UnmatchedDepositsPage() {
  return <TransactionsTable lockedToUnmatched={true} />;
}
